import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'

interface IVisibility {
  id: number
  name: string
  options: any
}

function VisibilityAutocomplete({ value, handleInputChange, options }: any) {
  const { t } = useTranslation(['global'])

  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  return (
    <Autocomplete
      id="autocomplete-visibility"
      disableClearable
      value={value || null}
      onChange={(_, newValue) => {
        handleInputChange('visibility', newValue)
      }}
      options={options}
      getOptionLabel={(option: IVisibility) => option.name}
      renderInput={params => (
        <TextField
          {...params}
          label={t('visibility')}
          variant="filled"
          InputLabelProps={{ shrink: true }}
          error={errorForm.visibility}
          helperText={msgForm.visibility}
        />
      )}
    />
  )
}

export default VisibilityAutocomplete
